//AuthContext.js

import React, { createContext, useState, useEffect, useContext } from 'react';
import { useGlobalContext } from './GlobalContext';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // New loading state
    const [userDetails, setUserDetails] = useState(null);
    const [, dispatch] = useGlobalContext();

    useEffect(() => {
        setIsLoading(true);
        const loggedInUser = localStorage.getItem("user");
        if (loggedInUser) {
            const foundUser = JSON.parse(loggedInUser);
            dispatch({ type: 'SAVE_CONFIG', payload: foundUser })
            setIsLoggedIn(true);
            setUserDetails(foundUser);
        }
        setIsLoading(false);
        // eslint-disable-next-line
    }, []);


    const login = (user) => {
        setIsLoggedIn(true);
        setUserDetails(user);
        localStorage.setItem("user", JSON.stringify(user));
    };

    const logout = () => {
        setIsLoggedIn(false);
        setUserDetails(null);
        localStorage.removeItem("user");
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, isLoading, userDetails, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
